module.exports = __webpack_public_path__ + "static/media/niuniu_m_game.a666240.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/niuniu_m_game.mp4
// module id = 7tfa
// module chunks = 0